module.exports = __webpack_public_path__ + "img/groups_black_24dp_outline.b632a096.svg";